module.exports = __webpack_public_path__ + "assets/9033e41b330c4048fc07b9db0a5b3068.png";